import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BellIcon } from 'lucide-react';
import { SiteLogo } from '../components/SiteLogo';
import { ConfirmSteps } from '../components/thankyou/ConfirmSteps';
import { WeddingVideos } from '../components/thankyou/WeddingVideos';
import { ReviewsWall } from '../components/thankyou/ReviewsWall';
export function ThankYou() {
  useEffect(() => {
    document.title = 'Confirm your tour — Twenty Mile House';
  }, []);
  return <div className="min-h-screen w-full bg-white text-ink" data-id="element-115" data-mp="2xrhf1jjlbhmn">
      <header className="relative flex items-center justify-center border-b border-ink/10 px-6 py-4" data-id="element-116" data-mp="2xpo9k7kpr3g8">
        <SiteLogo size="sm" data-id="element-117" data-mp="32izhyd56bsa9" />
        <Link to="/bay-area" className="absolute right-6 font-sans text-[10px] font-medium uppercase tracking-[0.25em] text-ink/60 transition-colors duration-150 hover:text-ink md:right-10" data-id="element-118" data-mp="37haremrk40ry">
          Return to site
        </Link>
      </header>

      <main data-id="element-119" data-mp="3hddtjsmerzew">
        <section className="mx-auto max-w-xl px-6 pt-12 text-center" data-id="element-120" data-mp="3hd401v25na4g">
          <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-full border border-gold/50 bg-notice" data-id="element-121" data-mp="287h1298x0xzz">
            <BellIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-122" data-mp="2395se1ucwtjc" />
          </span>
          <p className="mt-5 font-sans text-[10px] font-semibold uppercase tracking-[0.35em] text-gold" data-id="element-123" data-mp="1y9sxcttc0g5o">
            One step remaining
          </p>
          <h1 className="mt-3 font-sans text-2xl font-extrabold uppercase leading-tight tracking-wide text-ink md:text-3xl" data-id="element-124" data-mp="2qwnf3iyrl1fg">
            Your private tour
            <br data-id="element-125" data-mp="2lzn895u3buna" />
            isn’t confirmed yet.
          </h1>
          <p className="mx-auto mt-4 max-w-md font-body text-[15px] leading-relaxed text-ink/70" data-id="element-126" data-mp="2h59hxhuacdph">
            We’ve received your request. Before the Twenty Mile House team can hold your date,{' '}
            <strong className="font-semibold text-ink" data-id="element-127" data-mp="39nokopue3v7z">
              reply to the text we just sent to the number you gave us
            </strong>{' '}
            — it only takes a second and locks in your tour.
          </p>
        </section>

        <ConfirmSteps data-id="element-128" data-mp="17xprpnuzfe1q" />

        <div className="mt-16" data-id="element-129" data-mp="17xz94n1yocvt">
          <WeddingVideos data-id="element-130" data-mp="17x6bqcow6zqc" />
          <ReviewsWall data-id="element-131" data-mp="17zk4ug00i1v9" />
        </div>
      </main>
    </div>;
}